module.exports = __webpack_public_path__ + "img/main4.fb640674.png";